import React from 'react'
const cardsData = [
    {
      title: "Management Techniques",
      content: "We give you the tools to set your family to be successful.",
      image: "./dog1.jpeg",
      color: "bg-yellow-300",
    },
    {
      title: "Strengthen Bond",
      content: "We help you bridge the gap between you and your dog.",
      image: "./dog2.jpeg",
      color: "bg-blue-300",
    },
    {
      title: "Socialization",
      content:
        "Training increases your dog's confidence to explore the surroundings.",
      image: "./dog3.jpeg",
      color: "bg-green-300",
    },
    {
      title: "Mental Stimulation",
      content: "Engaging your dog's mind is as important as physical exercise.",
      image: "./dog4.jpeg",
      color: "bg-red-300",
    },
  ];
const Dogtraning = () => {
  return (
    <div>
    <div className='text-center md:pl-[500px] ' style={{ backgroundImage: 'url(./dogtraning.jpg)', height:"700px", backgroundSize: 'cover', backgroundPosition: 'center' }}>
        <p className='text-5xl text-white font-bold text-center pt-[300px]'>Dog Training Service at Home</p>
        <p className='text-white text-center font-semibold text-2xl pt-10'>Dog-friendly, one-on-one dog training</p>
        <button className='bg-orange-500 w-[300px] h-[60px] text-center rounded-xl text-white font-bold text-xl mt-9'>Book a Session</button>
    </div>
    <div className="max-w-4xl mx-auto px-4 py-8">
      <h1 className="text-3xl font-bold text-center text-gray-800 mb-4">
        Dog Training - Why it is so important?
      </h1>
      <p className="text-center text-gray-600 mb-8">
        Dog Training is an investment that pays off by making life with your dog easier and more enjoyable.
      </p>
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-6">
        {cardsData.map((card, index) => (
          <div
            key={index}
            className={`p-6 rounded-lg shadow-lg text-center ${card.color}`}
          >
            <img
              src={card.image}
              alt={card.title}
              className="w-24 h-24 mx-auto rounded-full mb-4"
            />
            <h3 className="text-lg font-semibold text-gray-800 mb-2">
              {card.title}
            </h3>
            <p className="text-gray-700">{card.content}</p>
          </div>
        ))}
      </div>
    </div>
    <div className="max-w-5xl mx-auto px-4 py-8">
      <h1 className="text-3xl font-bold text-gray-800 text-center">
        A Dog-Friendly Training Experience
      </h1>
      <div className="flex flex-col lg:flex-row items-center lg:items-start lg:justify-between mt-8 gap-8">
        <div className="lg:w-1/2 text-gray-700">
          <h2 className="text-2xl font-semibold mb-4">Our Trainers & Methods</h2>
          <p className="mb-4">
            Adopt a Pet certified pet trainers are educated and passionate about
            the well-being of pets and pet parents and are dedicated to
            strengthening the bond between them.
          </p>
          <p className="mb-4">
            Instructors are taught science-based training principles that reward
            appropriate dog behaviors instead of punishing negative ones.
          </p>
          <p className="mb-4">
            Positive Dog Training at home is a rewards-based approach to
            teaching pet parents how dogs think, learn, and communicate with
            others.
          </p>
          <p>
            Our dog trainers can build customized training plans to meet your
            goals and lifestyle.
          </p>
        </div>

        <div className="lg:w-1/2 flex justify-center h-[400px]">
          <img
            src="//dm6g3jbka53hp.cloudfront.net/static-images/dog-training-20200520.png"
            alt="Dog Training"
            className="rounded-lg shadow-lg"
          />
        </div>
      </div>
    </div>
    </div>
  )
}

export default Dogtraning
